<span class='cell-real-estate-mortgages-calculator_legend_item'>
	<span class='cell-real-estate-mortgages-calculator_legend_item-name'><%= name %></span>
	<span class='cell-real-estate-mortgages-calculator_legend_item-value'><%= y %></span>
</span>
<% if (key === "stamp_duties") { %>
  <span class='cell-real-estate-mortgages-calculator_legend_sub_item first-item'>
    <span >
      <%= I18n.t('concepts.real_estate.mortgages.calculator.data.labels.ad_valorem_stamp_duty') %>
    </span>
    <span class='cell-real-estate-mortgages-calculator_legend_sub_item-value'><%= ad_valorem_stamp_duty %></span>
  </span>
<% } %>
<% if (key === "other_fees") { %>
	<span class='cell-real-estate-mortgages-calculator_legend_sub_item first-item'>
		<span ><%= I18n.t('concepts.real_estate.mortgages.calculator.data.labels.commission.title') %></span>
		<span class='cell-real-estate-mortgages-calculator_legend_sub_item-value'><%= commission %></span>
	</span>
	<span class='cell-real-estate-mortgages-calculator_legend_sub_item last-item'>
		<span>
      <%= I18n.t('concepts.real_estate.mortgages.calculator.data.labels.legal_fee') %>
    </span>
		<span class='cell-real-estate-mortgages-calculator_legend_sub_item-value'><%= legal_fee %></span>
	</span>
<% } %>
